import React from 'react';
import './Legal.css';

const TermsOfService: React.FC = () => {
  return (
    <div className="legal-container">
      <div className="legal-card">
        <div className="legal-header">
          <h1>Terms of Service</h1>
          <p className="legal-updated">Last Updated: March 27, 2026</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing or using the Sermyble platform ("Platform"), operated by ASL Information Services, 
              you agree to be bound by these Terms of Service ("Terms"). If you do not agree, please do not use the Platform.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Platform Overview</h2>
            <p>
              Sermyble provides a technology platform enabling food court operators ("Partners") to manage 
              their food court operations, including but not limited to:
            </p>
            <ul>
              <li>Menu management and digital ordering</li>
              <li>Order management and real-time tracking</li>
              <li>Customer interaction and notifications</li>
              <li>Analytics and business insights</li>
              <li>Payment processing and settlements</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Partner Registration</h2>
            <p>To register as a Partner, you must:</p>
            <ul>
              <li>Be at least 18 years of age</li>
              <li>Provide valid identification (PAN, GST, FSSAI as applicable)</li>
              <li>Maintain all necessary licenses and permits for food service operations</li>
              <li>Provide accurate and complete registration information</li>
              <li>Maintain the security of your account credentials</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Service Charges</h2>
            <p>Sermyble charges the following platform fees:</p>
            <div className="legal-pricing">
              <div className="price-item">
                <span className="price-label">Orders below ₹100</span>
                <span className="price-value">₹0.50 per order</span>
              </div>
              <div className="price-item">
                <span className="price-label">Orders above ₹100</span>
                <span className="price-value">₹1.00 per order</span>
              </div>
            </div>
            <p className="legal-note">
              Sermyble reserves the right to modify pricing with 30 days' prior notice to Partners.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Partner Obligations</h2>
            <ul>
              <li>Comply with all applicable food safety regulations including FSSAI</li>
              <li>Maintain valid GST registration and file returns as required</li>
              <li>Ensure food quality and hygiene standards at all times</li>
              <li>Process orders in a timely manner once accepted</li>
              <li>Keep menu items and pricing up to date on the Platform</li>
              <li>Not engage in fraudulent or deceptive practices</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Intellectual Property</h2>
            <p>
              All content, trademarks, logos, and software on the Platform are the property of ASL Information Services. 
              Partners may not copy, reproduce, or distribute Platform materials without prior written consent.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Termination</h2>
            <p>
              Either party may terminate the partnership by providing <strong>30 days' written notice</strong>. 
              Sermyble may immediately terminate access in the event of:
            </p>
            <ul>
              <li>Breach of these Terms</li>
              <li>Fraudulent activity</li>
              <li>Failure to maintain required licenses</li>
              <li>Non-payment of outstanding fees</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>8. Limitation of Liability</h2>
            <p>
              Sermyble shall not be liable for any indirect, incidental, or consequential damages arising from 
              the use of the Platform. Our total liability shall not exceed the fees paid by the Partner in the 
              preceding 12 months.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Dispute Resolution</h2>
            <p>
              Any disputes arising from these Terms shall be resolved through arbitration in Hyderabad, Telangana, 
              India, in accordance with the Arbitration and Conciliation Act, 1996.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Contact</h2>
            <p>For questions about these Terms, contact us at:</p>
            <div className="legal-contact">
              <p><strong>ASL Information Services</strong></p>
              <p>Email: <a href="mailto:info@aslinformationservices.com">info@aslinformationservices.com</a></p>
              <p>Phone: <a href="tel:+917093281075">+91 70932 81075</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
